var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailUploadLine = function SvgMailUploadLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.8 5.143-4.757 4.26L3.2 5.13v7.07h5.4v1.2h-6a.6.6 0 0 1-.6-.6V3.2a.6.6 0 0 1 .6-.6h10.8a.6.6 0 0 1 .6.6V8h-1.2zM12.5 3.8H3.508l4.53 3.997z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.8 11.6h1.8V14h1.2v-2.4h1.8l-2.4-2.4z"
  })));
};
export default SvgMailUploadLine;